module.exports = __webpack_public_path__ + "img/missedpenalty.c48fc47c.png";